export const invoiceHeroFeatures = [
  {
    icon: '/assets/acceptPayments.svg',
    label: 'Accept payments in NGN & USD',
  },
  {
    icon: '/assets/paymentLink.svg',
    label: 'Create payment links in seconds',
  },
  {
    icon: '/assets/sendProfessionalInvoice.svg',
    label: 'Send professional invoices',
  },
  {
    icon: '/assets/trackPayment.svg',
    label: 'Track payments in real time',
  },
];

const flagPath = (emoji) =>
  `/assets/flags/${encodeURIComponent(emoji)}.png`;

export const invoiceHeroCurrencies = [
  { code: 'NGN', flag: flagPath('🇳🇬') },
  { code: 'USD', flag: flagPath('🇺🇸') },
  { code: 'CAD', flag: flagPath('🇨🇦') },
  { code: 'GBP', flag: flagPath('🇬🇧') },
  { code: 'KES', flag: flagPath('🇰🇪') },
  { code: 'RWF', flag: flagPath('🇷🇼') },
  { code: 'GHS', flag: flagPath('🇬🇭') },
  { code: 'XAF', flag: flagPath('🇨🇲') },
];

export const invoicePlatformMobileCurrencyRows = [
  ['NGN', 'USD', 'CAD', 'GBP'],
  ['GHS', 'KES', 'RWF', 'XAF'],
];

export const ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.fastamoniorg.bizflex';
export const IOS_APP_URL =
  'https://apps.apple.com/us/app/bizflex-africa/id6754340965';

export const INVOICE_CHECK_ICON = '/assets/invoice/check-circle(1).png';

export const invoicePlatformHighlights = [
  'Accept payments in NGN & USD',
  'Create payment links in seconds',
  'Send professional invoices',
  'Track payments in real time',
  'Set expiry dates and limits',
];

export const invoicePlatformSection = {
  title: 'One Platform. Two Powerful Ways to Get Paid.',
  subtitleLine1:
    'BizFlex combines Payment Links and Smart Invoicing into a seamless solution, helping',
  subtitleLine2:
    'you collect payments faster, stay organized, and maintain complete revenue visibility.',
  mobileSubtitleLine1: 'BizFlex combines Payment Links and Smart',
  mobileSubtitleLine2: 'Invoicing into a seamless solution.',
  cards: [
    {
      id: 'payment-links',
      icon: '/assets/invoice/link.png',
      title: 'Payment Links',
      description:
        'The fastest way to collect one-time or recurring payments without a website. Just share and get paid.',
      ctaLabel: 'Explore Payment Links',
      borderColor: '#00C48C',
      bgColor: '#00C48C1A',
      titleColor: '#0F172B',
      descriptionColor: '#64748B',
      ctaColor: '#0F172B',
    },
    {
      id: 'smart-invoicing',
      icon: '/assets/invoice/file-text.png',
      title: 'Smart Invoicing',
      description:
        'Automate your billing process with professional invoices, automated reminders, and real-time tracking.',
      ctaLabel: 'Explore Smart Invoicing',
      borderColor: '#6C3FF5',
      bgColor: '#6C3FF51A',
      titleColor: '#0F172B',
      descriptionColor: '#64748B',
      ctaColor: '#0F172B',
    },
  ],
};

export const PAYMENT_LINK_UI_IMAGE = '/assets/invoice/payment-link-ui.png';

export const invoicePaymentLinksSection = {
  titleLine1: 'Payment Links That',
  titleLine2: 'Work Everywhere',
  description:
    'Instantly create and share payment links for products, services, subscriptions, donations, events, and more.',
  mobileDescription:
    'Instantly create and share payment links for products, services, subscriptions, and more.',
  audienceTagRows: [
    ['Freelancers', 'Agencies', 'Consultants', 'Online Sellers'],
    ['NGOs', 'Churches', 'Creators', 'Event Organizers'],
    ['Service Providers'],
  ],
  mobileAudienceTagRows: [
    ['Freelancers', 'Agencies', 'Consultants'],
    ['Online Sellers', 'Creators', 'Churches'],
    ['NGOs', 'Event Organizers'],
    ['Service Providers'],
  ],
  features: [
    {
      id: 'expiry-dates',
      title: 'Set Expiry Dates',
      description:
        'Limit link availability for flash sales or time-bound offers.',
    },
    {
      id: 'usage-limits',
      title: 'Usage Limits',
      description:
        'Control stock levels by limiting number of successful payments.',
    },
  ],
};

export const INVOICE_GREEN_CHECK_ICON = '/assets/invoice/green-check-circle.png';
export const INVOICE_PRODUCT_A_IMAGE = '/assets/invoice/productA.png';
export const INVOICE_PRODUCT_B_IMAGE = '/assets/invoice/productB.png';
export const INVOICE_PRODUCT_C_IMAGE = '/assets/invoice/serviceC.png';

export const invoiceStorefrontSection = {
  title: 'Build Your Own Digital Storefront',
  description:
    'Transform payment links into a professional storefront. Showcase products, services, pricing, images, and brand identity.',
  products: [
    { id: 'product-a-1', image: INVOICE_PRODUCT_A_IMAGE, alt: 'Product A' },
    { id: 'product-b-1', image: INVOICE_PRODUCT_B_IMAGE, alt: 'Product B' },
    { id: 'product-b-2', image: INVOICE_PRODUCT_B_IMAGE, alt: 'Product B' },
    { id: 'service-c-1', image: INVOICE_PRODUCT_C_IMAGE, alt: 'Service C' },
    { id: 'service-c-2', image: INVOICE_PRODUCT_C_IMAGE, alt: 'Service C' },
    { id: 'service-c-3', image: INVOICE_PRODUCT_C_IMAGE, alt: 'Service C' },
  ],
  features: [
    'Custom Branding',
    'Product Showcase',
    'Professional Experience',
    'Mobile Optimized',
  ],
  ctaLabel: 'Start Accepting Payments',
};

export const REVIEW_PAYMENT_IMAGE = '/assets/invoice/reviewPayment.png';

export const invoiceDonationsSection = {
  title: 'Accept Donations Anywhere',
  description:
    'Collect donations without building a fundraising website. Create a dedicated donation link and receive contributions instantly.',
  audienceTagRows: [
    ['Nonprofits', 'NGOs', 'Religious Organizations', 'Community Projects'],
    ['Fundraisers', 'Charity Campaigns'],
  ],
  mobileAudienceTagRows: [
    ['Nonprofits', 'Community Projects'],
    ['Religious Organizations', 'NGOs'],
    ['Fundraisers', 'Charity Campaigns'],
  ],
};

export const TRACK_PAYMENT_IMAGE = '/assets/invoice/trackpayment.png';
export const TRACK_PAYMENT_MOBILE_IMAGE =
  '/assets/invoice/trackpayment_mobile.png';

export const invoiceTrackPaymentsSection = {
  title: 'Track Every Payment in Real Time',
  mobileTitleLine1: 'Track Every Payment in',
  mobileTitleLine2: 'Real Time',
  descriptionLine1:
    'Gain complete visibility into payment activity. Monitor successful, pending, and failed',
  descriptionLine2:
    'payments, customer details, payment timestamps, and revenue performance.',
  mobileDescriptionLine1: 'Gain complete visibility into payment activity',
  mobileDescriptionLine2: 'and customer performance.',
  ctaLabel: 'Start Accepting Payment',
  stats: [
    { id: 'total-payments', label: 'Total Payments', value: '24.8k' },
    {
      id: 'success-rate',
      label: 'Success Rate',
      value: '99.4%',
      showTrend: true,
    },
    { id: 'pending', label: 'Pending', value: '12' },
    {
      id: 'net-revenue',
      label: 'Net Revenue',
      mobileLabel: 'Net Payout',
      value: '$1.2M',
    },
  ],
};

export const INVOICE_CHECK_BLUE_ICON = '/assets/invoice/check_blue.svg';
export const INVOICE_CARD_IMAGE = '/assets/invoice/invoice-card.png';

export const invoiceSmartInvoicingSection = {
  title: 'Smart Invoicing Built for Modern Businesses',
  titleLine1: 'Smart Invoicing Built for',
  titleLine2: 'Modern Businesses',
  description:
    'Create professional invoices in minutes. Automate follow-ups, monitor payment progress, and get paid faster.',
  mobileDescriptionLine1: 'Create professional invoices in minutes.',
  mobileDescriptionLine2: 'Automate follow-ups, monitor payment',
  mobileDescriptionLine3: 'progress, and get paid faster.',
  features: [
    'Custom Invoice Numbers',
    'Customer Information',
    'Product & Service Billing',
    'Tax Support',
    'NGN & USD Invoicing',
    'Downloadable Records',
  ],
  highlightCards: [
    {
      id: 'real-time-tracking',
      title: 'Real-Time Tracking',
      description: 'See exactly when your client opens the invoice.',
      bgColor: '#6C3FF51A',
      titleColor: '#6C3FF5',
    },
    {
      id: 'automated-reminders',
      title: 'Automated Reminders',
      description: "Set it and forget it... we'll chase overdue payments.",
      bgColor: '#00C48C1A',
      titleColor: '#00C48C',
    },
  ],
};

export const INVOICE_GLOBAL_PAYMENTS_IMAGE = '/assets/invoice/image-visual.png';
export const INVOICE_GLOBAL_PAYMENTS_IMAGE_MOBILE =
  '/assets/invoice/image-visual (1).png';

export const invoiceGlobalPaymentsSection = {
  title: 'Global Sales, Local Payments',
  description:
    'Invoice your clients in USD, NGN. Accept payments globally with automated conversion and mid-market exchange rates.',
  currencies: [
    {
      id: 'usd',
      name: 'United States Dollar',
      description: 'Reach international markets effortlessly',
      flag: flagPath('🇺🇸'),
      selected: true,
    },
    {
      id: 'ngn',
      name: 'Nigerian Naira',
      description: 'Perfect for local business and vendors',
      flag: flagPath('🇳🇬'),
      selected: false,
    },
  ],
};

export const INVOICE_REPEAT_ICON = '/assets/invoice/repeat.png';
export const INVOICE_PERCENT_ICON = '/assets/invoice/percent.png';
export const INVOICE_USERS_ICON = '/assets/invoice/users.png';

export const invoiceScalabilitySection = {
  title: 'Everything You Need to Scale',
  subtitle:
    'Built for freelancers and agencies who need professional financial tools without the complexity.',
  subtitleLine1:
    'Built for freelancers and agencies who need professional financial tools without the',
  subtitleLine2: 'complexity.',
  subtitleMobileLine1: 'Built for freelancers and agencies who need',
  subtitleMobileLine2: 'professional financial tools without the',
  subtitleMobileLine3: 'complexity.',
  cards: [
    {
      id: 'recurring-invoices',
      icon: INVOICE_REPEAT_ICON,
      title: 'Recurring Invoices',
      description: 'Automate billing for retainers and subscriptions.',
      descriptionMobileLine1: 'Automate billing for retainers and',
      descriptionMobileLine2: 'subscriptions.',
    },
    {
      id: 'payment-reminders',
      icon: '/assets/payments-link/bell (1).png',
      title: 'Payment Reminders',
      description: 'Smart follow-ups that get you paid 60% faster.',
      descriptionMobileLine1: 'Smart follow-ups that get you paid 60%',
      descriptionMobileLine2: 'faster.',
    },
    {
      id: 'multi-currency',
      icon: '/assets/payments-link/globe (1).png',
      title: 'Multi-Currency',
      description: 'Invoice and collect in NGN, USD, GBP and more.',
      descriptionMobileLine1: 'Invoice and collect in NGN, USD, GBP',
      descriptionMobileLine2: 'and more.',
    },
    {
      id: 'tax-support',
      icon: INVOICE_PERCENT_ICON,
      title: 'Tax Support',
      description: 'Automatic VAT and sales tax calculations per region.',
      descriptionMobileLine1: 'Automatic VAT and sales tax',
      descriptionMobileLine2: 'calculations per region.',
    },
    {
      id: 'client-management',
      icon: INVOICE_USERS_ICON,
      title: 'Client Management',
      description: 'Keep a directory of your clients and their payment history.',
      descriptionMobileLine1: 'Keep a directory of your clients and their',
      descriptionMobileLine2: 'payment history.',
    },
    {
      id: 'real-time-tracking',
      icon: '/assets/payments-link/bar-chart-2.png',
      title: 'Real-Time Tracking',
      description: 'Monitor views and status of every invoice sent.',
      descriptionMobileLine1: 'Monitor views and status of every',
      descriptionMobileLine2: 'invoice sent.',
    },
  ],
};

export const INVOICE_YELLOW_CHECK_ICON = '/assets/invoice/yellow-check.png';
export const INVOICE_AUTOMATED_FOLLOWUPS_IMAGE = '/assets/invoice/left-image.png';

export const invoiceAutomatedFollowupsSection = {
  title: 'Automated Follow-ups',
  description:
    "Set it and forget it. We'll automatically send professional reminders to your clients when payments are due or overdue. No more awkward chasing.",
  features: [
    {
      id: 'smart-scheduling',
      title: 'Smart Scheduling',
      description:
        'Choose when reminders are sent—before, on, or after the due date.',
    },
    {
      id: 'multi-channel-delivery',
      title: 'Multi-Channel Delivery',
      description:
        'Reminders go out via Email, SMS, and WhatsApp for maximum reach.',
    },
  ],
};

export const INVOICE_STAR_ICON = '/assets/payments-link/starr.png';
export const INVOICE_BOX_ICON = '/assets/invoice/box.png';
export const INVOICE_PERSON_1_IMAGE = '/assets/invoice/person1.png';
export const INVOICE_PERSON_2_IMAGE = '/assets/invoice/person2.png';
export const INVOICE_PERSON_3_IMAGE = '/assets/invoice/person3.png';

export const invoiceHowItWorksSection = {
  title: 'How It Works',
  stepIcon: INVOICE_BOX_ICON,
  steps: [
    {
      id: 'create-account',
      number: 1,
      label: 'Create a BizFlex account',
    },
    {
      id: 'choose-product',
      number: 2,
      label: 'Choose Links or Invoicing',
    },
    {
      id: 'customize',
      number: 3,
      label: 'Customize your request',
    },
    {
      id: 'share',
      number: 4,
      label: 'Share or send your invoice',
    },
    {
      id: 'track',
      number: 5,
      label: 'Track payments in real time',
    },
    {
      id: 'get-paid',
      number: 6,
      label: 'Get paid faster and grow',
    },
  ],
};

export const INVOICE_TESTIMONIAL_AVATAR_SARAH = '/assets/invoice/Sarah.png';
export const INVOICE_TESTIMONIAL_AVATAR_DAVID = '/assets/invoice/Okoro.png';

export const invoiceTestimonialsSection = {
  title: 'Trusted by Thousands of Creators',
  subtitle:
    'Join the modern entrepreneurs scaling their businesses with Invoicing.',
  testimonials: [
    {
      id: 'sarah-johnson',
      quote:
        'Invoicing has completely streamlined our billing process. We went from chasing payments for weeks to getting paid within 48 hours.',
      quoteLines: [
        'Invoicing has completely streamlined our',
        'billing process. We went from chasing payments for weeks',
        'to getting paid within 48 hours.',
      ],
      name: 'Sarah Johnson',
      role: 'Freelance Designer',
      avatar: INVOICE_TESTIMONIAL_AVATAR_SARAH,
    },
    {
      id: 'david-okoro',
      quote:
        'Creating and sending professional invoices used to take me hours. Now I generate them in seconds and my clients pay faster than ever.',
      quoteLines: [
        'Creating and sending professional invoices used to take me',
        'hours. Now I generate them in seconds and my clients pay',
        'faster than ever.',
      ],
      name: 'David Okoro',
      role: 'Small Business Owner',
      avatar: INVOICE_TESTIMONIAL_AVATAR_DAVID,
    },
  ],
};

export const INVOICE_FINAL_CTA_GRADIENT_START = '#0F2F49';
export const INVOICE_FINAL_CTA_GRADIENT_END = '#3F4BB1';

export const invoiceFinalCtaSection = {
  title: 'Everything You Need to Get Paid Faster',
  description:
    'Start sending professional invoices globally today. Available in NGN and USD.',
  descriptionMobileLine1: 'Start sending professional invoices globally',
  descriptionMobileLine2: 'today. Available in NGN and USD.',
  ctaLabel: 'Get Started',
  learnMoreLabel: 'Learn more about BizFlex',
  learnMoreHref: '/',
};
